/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import {
  addEdge,
  Background,
  Controls,
  type EdgeTypes,
  getConnectedEdges,
  getIncomers,
  getNodesBounds,
  getOutgoers,
  getViewportForBounds,
  MarkerType,
  MiniMap,
  ReactFlow,
  ReactFlowProvider,
  useEdgesState,
  useNodesState,
  useReactFlow,
} from '@xyflow/react'
import '@xyflow/react/dist/style.css'
import '@/styles/playground.css'

import {
  Add,
  Box as BoxIcon,
  Clean,
  DropPhotoFilled,
  FolderOpen,
  GroupObjects,
  Save,
  Template,
} from '@carbon/icons-react'
import {
  Box,
  Button,
  HStack,
  IconButton,
  Input,
  Menu,
  Popover,
  Portal,
  Separator,
  SimpleGrid,
  Text,
} from '@chakra-ui/react'
import { pdf } from '@react-pdf/renderer'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, useSearch } from '@tanstack/react-router'
import { toPng } from 'html-to-image'
import { ChevronRightIcon, FileText, Image, Palette, Share2, Sparkles } from 'lucide-react'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { createRoot } from 'react-dom/client'
import AiChatDrawer from '@/components/playground/AiChatDrawer'
import ButtonEdge from '@/components/playground/ButtonEdge'

import ContextMenu from '@/components/playground/ContextMenu'
import CustomerCard from '@/components/playground/CustomerCard'
import DynamicNode from '@/components/playground/DynamicNode'
import ExportImageDialog from '@/components/playground/ExportImageDialog'
import ExportPdfDialog, { type PdfExportOptions } from '@/components/playground/ExportPdfDialog'
import type { ExportOptions } from '@/components/playground/exportTypes'
import GenericNode from '@/components/playground/GenericNode'
import GroupNode from '@/components/playground/GroupNode'
import { ImageExportLayout } from '@/components/playground/ImageExportLayout'
import LoadPlaygroundDialog from '@/components/playground/LoadPlaygroundDialog'
import { PlaygroundPdfDocument } from '@/components/playground/PlaygroundPdfDocument'
import SavePlaygroundDialog from '@/components/playground/SavePlaygroundDialog'
import SaveTemplateDialog from '@/components/playground/SaveTemplateDialog'
import SharePlaygroundDialog from '@/components/playground/SharePlaygroundDialog'
import TemplateGallery from '@/components/playground/TemplateGallery'
import { useAuth } from '@/contexts/AuthContext'
import type { FlowTemplate } from '@/lib/api'
import {
  aiApi,
  type ChatMessage,
  flowTemplatesApi,
  type NodeCategory,
  type PlaygroundAction,
  type PlaygroundNodeMenuItem,
  playgroundNodesApi,
  type SavedPlaygroundDetail,
} from '@/lib/api'
import ArmNode from '~/components/nodes/armNode'
import ArmSimpleNode from '~/components/nodes/armSimpleNode'
import BioReactorPharmaNode from '~/components/nodes/BioReactorPharmaNode'
import BatteriesNode from '~/components/nodes/batteriesNode'
import BoilerNode from '~/components/nodes/boilerNode'
import ConfluentNode from '~/components/nodes/ConfluentNode'
import CarComputerNode from '~/components/nodes/carComputerNode'
import CloudNode from '~/components/nodes/cloudNode'
import CloudNodeBi from '~/components/nodes/cloudNodeBi'
import CollisionNode from '~/components/nodes/collisionNode'
import ControlSystemNode from '~/components/nodes/controlSystemNode'
import ConveyorNode from '~/components/nodes/conveyorNode'
import DatalakeNode from '~/components/nodes/datalakeNode'
import DittoNode from '~/components/nodes/dittoNode'
import DittoNodeBi from '~/components/nodes/dittoNodeBi'
import DrillingNode from '~/components/nodes/drillingNode'
import DriverPadNode from '~/components/nodes/driverPadNode'
import EdgeBoxNode from '~/components/nodes/edgeBoxNode'
// Flow template node components (for rendering templates from all industries)
import EdgeNode from '~/components/nodes/edgeNode'
import EdgeNodeBi from '~/components/nodes/edgeNodeBi'
import EntBrokerNode from '~/components/nodes/entBrokerNode'
import EntBrokerNodeBi from '~/components/nodes/entBrokerNodeBi'
import EnvSensorNode from '~/components/nodes/envSensorNode'
import ErpNode from '~/components/nodes/erpNode'
import EvChargerNode from '~/components/nodes/evChargerNode'
// Pharma nodes
import FeederNode from '~/components/nodes/feederNode'
import HeaterNode from '~/components/nodes/heaterNode'
// Smart Building nodes
import HeatPumpNode from '~/components/nodes/heatpumpNode'
import HistorianNode from '~/components/nodes/historianNode'
import HmiBottomNode from '~/components/nodes/hmiBottomNode'
import HopperNode from '~/components/nodes/hopperNode'
import MachineLearningNode from '~/components/nodes/machineLearningNode'
import MachineLearningTopNode from '~/components/nodes/machineLearningTopNode'
import MesBottomNode from '~/components/nodes/mesBottomNode'
import MicroServiceNode from '~/components/nodes/microServiceNode'
import MobileNode from '~/components/nodes/mobileNode'
import MongoDBNode from '~/components/nodes/mongoDBNode'
import MotorNode from '~/components/nodes/motorNode'
import OcppGatewayNode from '~/components/nodes/ocppGatewayNode'
import OilWellNode from '~/components/nodes/oilWellNode'
import PaintNode from '~/components/nodes/paintNode'
// Oil & Gas nodes
import PipelineNode from '~/components/nodes/pipelineNode'
// Factory nodes
import PLCNode from '~/components/nodes/plcNode'
import PLCNodePhoenixContact from '~/components/nodes/plcNodePhoenixContact'
import PLCNodeRockwell from '~/components/nodes/plcNodeRockwell'
import PLCNodeSiemens from '~/components/nodes/plcNodeSiemens'
import PLCNodeWago from '~/components/nodes/plcNodeWago'
import PostgresNode from '~/components/nodes/postgresNode'
import PostgresNodeML from '~/components/nodes/postgresNodeML'
import PostgresTopNode from '~/components/nodes/postgresTopNode'
import PowerMeterNode from '~/components/nodes/powerMeterNode copy'
import PowerRegulatorNode from '~/components/nodes/powerRegulatorNode'
import RefineryNode from '~/components/nodes/refineryNode'
import ReportingNode from '~/components/nodes/reportingNode'
import RetailFuelNode from '~/components/nodes/retailFuelNode'
import StorageNode from '~/components/nodes/StorageNode'
import StoragePharmaNode from '~/components/nodes/StoragePharmaNode'
import ScadaTopNode from '~/components/nodes/scadaTopNode'
import ShippingNode from '~/components/nodes/shippingNode'
import SolarPanelNode from '~/components/nodes/solarPanelNode'
import StampingNode from '~/components/nodes/stampingNode'
import StreamingNode from '~/components/nodes/streamingNode'
import TankNode from '~/components/nodes/tankNode'
// Automotive/Logistics nodes
import TiresNode from '~/components/nodes/tiresNode'
import VentilationNode from '~/components/nodes/ventilationNode'
import WarehouseNode from '~/components/nodes/warehouseNode'
import WebNode from '~/components/nodes/webNode'
// Energy nodes
import WindTurbineNode from '~/components/nodes/windTubineNode'
import { toaster } from '~/toaster'

type PlaygroundSearch = {
  template?: string
}

export const Route = createFileRoute('/_app/playground')({
  component: PlaygroundPage,
  validateSearch: (search: Record<string, unknown>): PlaygroundSearch => {
    return {
      template: typeof search.template === 'string' ? search.template : undefined,
    }
  },
})

const InitEdges = []

const nodeTypes = {
  // Playground native nodes
  genericNode: GenericNode,
  dynamicNode: DynamicNode,
  groupNode: GroupNode,
  // HiveMQ nodes
  edgeNode: EdgeNode,
  edgeNodeBi: EdgeNodeBi,
  cloudNode: CloudNode,
  cloudNodeBi: CloudNodeBi,
  entBrokerNode: EntBrokerNode,
  entBrokerNodeBi: EntBrokerNodeBi,
  // IT/Integration nodes
  dittoNode: DittoNode,
  dittoNodeBi: DittoNodeBi,
  mobileNode: MobileNode,
  webNode: WebNode,
  machineLearningNode: MachineLearningNode,
  machineLearningTopNode: MachineLearningTopNode,
  microServiceNode: MicroServiceNode,
  postgresNode: PostgresNode,
  postgresNodeML: PostgresNodeML,
  postgresTopNode: PostgresTopNode,
  datalakeNode: DatalakeNode,
  streamingNode: StreamingNode,
  confluentNode: ConfluentNode,
  mongoDBNode: MongoDBNode,
  reportingNode: ReportingNode,
  historianNode: HistorianNode,
  erpNode: ErpNode,
  scadaTopNode: ScadaTopNode,
  hmiBottomNode: HmiBottomNode,
  mesBottomNode: MesBottomNode,
  // Factory/Manufacturing nodes
  plcNode: PLCNode,
  plcNodeSiemens: PLCNodeSiemens,
  plcNodeRockwell: PLCNodeRockwell,
  plcNodeWago: PLCNodeWago,
  plcNodePhoenixContact: PLCNodePhoenixContact,
  armNode: ArmNode,
  armSimpleNode: ArmSimpleNode,
  drillingNode: DrillingNode,
  paintNode: PaintNode,
  stampingNode: StampingNode,
  // Automotive/Logistics nodes
  tiresNode: TiresNode,
  collisionNode: CollisionNode,
  motorNode: MotorNode,
  tankNode: TankNode,
  carComputerNode: CarComputerNode,
  driverPadNode: DriverPadNode,
  warehouseNode: WarehouseNode,
  storageNode: StorageNode,
  conveyorsNode: ConveyorNode,
  // Energy nodes
  windTurbineNode: WindTurbineNode,
  solarPanelNode: SolarPanelNode,
  evChargerNode: EvChargerNode,
  batteriesNode: BatteriesNode,
  controlSystemNode: ControlSystemNode,
  powerMeterNode: PowerMeterNode,
  powerRegulatorNode: PowerRegulatorNode,
  ocppGatewayNode: OcppGatewayNode,
  // Oil & Gas nodes
  pipelineNode: PipelineNode,
  refineryNode: RefineryNode,
  oilwellNode: OilWellNode,
  retailfuelNode: RetailFuelNode,
  // Pharma nodes
  feederNode: FeederNode,
  hopperNode: HopperNode,
  storagePharmaNode: StoragePharmaNode,
  bioReactorPharmaNode: BioReactorPharmaNode,
  shippingNode: ShippingNode,
  // Smart Building nodes
  heatPumpNode: HeatPumpNode,
  heaterNode: HeaterNode,
  boilerNode: BoilerNode,
  ventilationNode: VentilationNode,
  envSensorNode: EnvSensorNode,
  edgeBoxNode: EdgeBoxNode,
}

const edgeTypes = {
  button: ButtonEdge,
}

let id = 2
const getId = () => `${id++}`

// Helper to ensure group nodes have correct zIndex when loading
const normalizeNodes = (nodes: any[]) => {
  return nodes.map((node) => {
    if (node.type === 'groupNode') {
      return { ...node, zIndex: -1 }
    }
    return node
  })
}

function randomIntFromInterval(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

// Dynamic submenu component that works with API data
function DynamicSubMenu({
  category,
  onAddItem,
}: {
  category: NodeCategory
  onAddItem: (slug: string) => void
}) {
  return (
    <Menu.Root positioning={{ placement: 'right-start' }}>
      <Menu.TriggerItem>
        <HStack justify="space-between" w="full">
          <HStack gap={2}>
            <BoxIcon size={16} />
            <Text>{category.name}</Text>
          </HStack>
          <ChevronRightIcon size={16} />
        </HStack>
      </Menu.TriggerItem>
      <Portal>
        <Menu.Positioner>
          <Menu.Content minW="160px" zIndex={1001}>
            {category.nodes.map((node) => (
              <Menu.Item key={node.slug} value={node.slug} onClick={() => onAddItem(node.slug)}>
                <HStack gap={2}>
                  {node.logoUrl ? (
                    <img
                      src={node.logoUrl}
                      alt={node.name}
                      style={{ width: 16, height: 16, objectFit: 'contain' }}
                    />
                  ) : (
                    <BoxIcon size={16} />
                  )}
                  <Text>{node.name}</Text>
                </HStack>
              </Menu.Item>
            ))}
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  )
}

function PlaygroundContent() {
  const { hasMinRole } = useAuth()
  const isAdmin = hasMinRole('admin')
  const { template: templateSlug } = useSearch({ from: '/_app/playground' })

  const [nodes, setNodes, onNodesChange] = useNodesState([])
  const [edges, setEdges, onEdgesChange] = useEdgesState(InitEdges)
  const [menu, setMenu] = useState(null)
  const [initialNodeAdded, setInitialNodeAdded] = useState(false)
  const [templateLoaded, setTemplateLoaded] = useState(false)
  const ref = useRef(null)
  const { getViewport, screenToFlowPosition, fitView, getEdges: getFlowEdges } = useReactFlow()

  // Customer card state
  const [customerName, setCustomerName] = useState('')
  const [customerLogoUrl, setCustomerLogoUrl] = useState<string | null>(null)
  const [customerLogoFile, setCustomerLogoFile] = useState<File | null>(null)

  // Dialog state
  const [saveDialogOpen, setSaveDialogOpen] = useState(false)
  const [loadDialogOpen, setLoadDialogOpen] = useState(false)
  const [templateGalleryOpen, setTemplateGalleryOpen] = useState(false)
  const [saveTemplateDialogOpen, setSaveTemplateDialogOpen] = useState(false)
  const [currentPlaygroundId, setCurrentPlaygroundId] = useState<string | null>(null)
  const [currentPlaygroundName, setCurrentPlaygroundName] = useState('')
  const [currentPlaygroundIsPublic, setCurrentPlaygroundIsPublic] = useState(false)

  // PDF export state
  const [isExportingPdf, setIsExportingPdf] = useState(false)
  const [exportPdfDialogOpen, setExportPdfDialogOpen] = useState(false)

  // Image export state
  const [isExportingImage, setIsExportingImage] = useState(false)
  const [exportImageDialogOpen, setExportImageDialogOpen] = useState(false)

  // Share dialog state
  const [shareDialogOpen, setShareDialogOpen] = useState(false)

  // Image import state
  const [_isAnalyzingImage, setIsAnalyzingImage] = useState(false)
  const _imageInputRef = useRef<HTMLInputElement>(null)

  // Background image state
  const [backgroundImageUrl, setBackgroundImageUrl] = useState<string | null>(null)
  const backgroundInputRef = useRef<HTMLInputElement>(null)

  // Canvas background color state
  const DEFAULT_CANVAS_COLOR = '#F7F9FB'
  const CANVAS_COLORS = [
    { name: 'Default', value: '#F7F9FB' },
    { name: 'White', value: '#FFFFFF' },
    { name: 'Light Gray', value: '#E5E7EB' },
    { name: 'Warm Gray', value: '#F5F5F4' },
    { name: 'Slate', value: '#F1F5F9' },
    { name: 'Light Blue', value: '#EFF6FF' },
    { name: 'Light Green', value: '#F0FDF4' },
    { name: 'Light Yellow', value: '#FEFCE8' },
    { name: 'Light Purple', value: '#FAF5FF' },
    { name: 'Dark', value: '#1E1E2E' },
  ]
  const [canvasColor, setCanvasColor] = useState(DEFAULT_CANVAS_COLOR)
  const [hexInput, setHexInput] = useState(DEFAULT_CANVAS_COLOR)

  // AI Chat drawer state
  const [aiDrawerOpen, setAiDrawerOpen] = useState(false)
  const [chatMessages, setChatMessages] = useState<ChatMessage[]>([])
  const [isChatLoading, setIsChatLoading] = useState(false)
  const [lastActionSummary, setLastActionSummary] = useState<string | null>(null)

  // Fetch nodes from API for menu
  const { data: menuData } = useQuery({
    queryKey: ['playground-nodes', 'menu'],
    queryFn: () => playgroundNodesApi.getForMenu(),
  })

  // Create a lookup map for quick access to node data by slug
  const nodeDataBySlug = useMemo(() => {
    const map = new Map<string, PlaygroundNodeMenuItem>()
    if (menuData) {
      // Add categorized nodes
      for (const category of menuData.categories) {
        for (const node of category.nodes) {
          map.set(node.slug, node)
        }
      }
      // Add uncategorized nodes
      for (const node of menuData.uncategorized) {
        map.set(node.slug, node)
      }
    }
    return map
  }, [menuData])

  // Load template from URL parameter if provided
  useEffect(() => {
    if (templateSlug && !templateLoaded) {
      flowTemplatesApi
        .getBySlug(templateSlug)
        .then((template) => {
          // Reset the ID counter based on template nodes
          const maxId = Math.max(0, ...template.nodes.map((n: any) => parseInt(n.id) || 0))
          id = maxId + 1

          // Load nodes and edges from template (normalize to ensure group zIndex)
          setNodes(normalizeNodes(template.nodes as any))
          setEdges(template.edges as any)

          // Reset customer branding for fresh template
          setCustomerName('')
          setCustomerLogoUrl(null)
          setCustomerLogoFile(null)

          // Clear current playground info since this is a new template
          setCurrentPlaygroundId(null)
          setCurrentPlaygroundName('')
          setCurrentPlaygroundIsPublic(false)

          setTemplateLoaded(true)
          setInitialNodeAdded(true) // Prevent default node from being added

          // Fit view after nodes are rendered
          setTimeout(() => {
            fitView({ padding: 0.1, duration: 200 })
          }, 100)
        })
        .catch((error) => {
          console.error('Failed to load template:', error)
          setTemplateLoaded(true) // Mark as loaded even on error to prevent retries
        })
    }
  }, [templateSlug, templateLoaded, setNodes, setEdges, fitView])

  // Add initial enterprise broker node once API data is available (only if no template is being loaded)
  useEffect(() => {
    if (menuData && !initialNodeAdded && !templateSlug) {
      const brokerData = nodeDataBySlug.get('enterprise-broker')
      if (brokerData) {
        setNodes([
          {
            id: '1',
            position: { x: 175, y: 0 },
            type: 'dynamicNode',
            data: {
              label: 'enterprise-broker',
              name: brokerData.name,
              logoUrl: brokerData.logoUrl,
              backgroundColor: brokerData.backgroundColor,
              externalLink: brokerData.externalLink,
            },
            origin: [0.5, 0.0] as [number, number],
          },
        ])
        setInitialNodeAdded(true)
      }
    }
  }, [menuData, nodeDataBySlug, initialNodeAdded, templateSlug, setNodes])

  // Calculate position at top center of visible viewport with random offset
  const getTopCenterPosition = useCallback(() => {
    // Get the flow container dimensions
    const flowContainer = ref.current
    if (!flowContainer) {
      return { x: 175, y: 50 } // Fallback position
    }

    const containerRect = flowContainer.getBoundingClientRect()

    // Calculate top center in screen coordinates
    // Center horizontally, position near top (100px from top)
    const screenX = containerRect.width / 2
    const screenY = 100

    // Convert screen position to flow position
    const flowPosition = screenToFlowPosition({ x: screenX, y: screenY })

    // Add small random offset so nodes don't stack exactly
    const randomOffsetX = randomIntFromInterval(-50, 50)
    const randomOffsetY = randomIntFromInterval(0, 30)

    return {
      x: flowPosition.x + randomOffsetX,
      y: flowPosition.y + randomOffsetY,
    }
  }, [screenToFlowPosition])

  const onAddItem = useCallback(
    (slug: string) => {
      const newId = getId()

      // Look up node data from the API
      const nodeInfo = nodeDataBySlug.get(slug)

      // Get position at top center of viewport
      const position = getTopCenterPosition()

      // Handle generic node specially
      if (slug === 'generic') {
        const newNode = {
          id: newId,
          position,
          type: 'genericNode',
          data: { label: slug },
          origin: [0.5, 0.0] as [number, number],
        }
        setNodes((nds) => nds.concat(newNode))
        return
      }

      // Create dynamic node with data from the API
      const newNode = {
        id: newId,
        position,
        type: 'dynamicNode',
        data: {
          label: slug,
          name: nodeInfo?.name || slug,
          logoUrl: nodeInfo?.logoUrl,
          backgroundColor: nodeInfo?.backgroundColor || '#FFFFFF',
          externalLink: nodeInfo?.externalLink,
        },
        origin: [0.5, 0.0] as [number, number],
      }

      setNodes((nds) => nds.concat(newNode))
    },
    [setNodes, nodeDataBySlug, getTopCenterPosition],
  )

  // Handler for adding a new group node
  const onAddGroup = useCallback(() => {
    const newId = getId()
    const position = getTopCenterPosition()

    const newNode = {
      id: newId,
      position,
      type: 'groupNode',
      zIndex: -1, // Ensure group renders behind other nodes
      data: {
        label: 'New Group',
        backgroundColor: 'rgba(200, 200, 200, 0.3)',
      },
      style: {
        width: 300,
        height: 200,
      },
    }

    setNodes((nds) => nds.concat(newNode))
  }, [setNodes, getTopCenterPosition])

  const DownloadPlayground = (content: unknown) => {
    const today = new Date()
    const filename = `playground-${today.toISOString()}.json`
    const filecontent = JSON.stringify(content)

    const element = document.createElement('a')
    element.setAttribute('href', `data:text/plain;charset=utf-8,${encodeURIComponent(filecontent)}`)
    element.setAttribute('download', filename)
    element.style.display = 'none'
    document.body.appendChild(element)
    element.click()
    document.body.removeChild(element)
  }

  const imageWidth = 1024 * 3
  const imageHeight = 768 * 3

  const _onClickTakeScreenshot = useCallback(() => {
    const nodesBounds = getNodesBounds(nodes)
    const today = new Date()

    const downloadImage = (dataUrl: string) => {
      const a = document.createElement('a')
      a.setAttribute('download', `playground-${today.toISOString()}.png`)
      a.setAttribute('href', dataUrl)
      a.click()
    }

    const viewport = getViewportForBounds(nodesBounds, imageWidth, imageHeight, 0.5, 2, 1)

    toPng(document.querySelector('.react-flow__viewport') as HTMLElement, {
      backgroundColor: '#fff',
      width: imageWidth,
      height: imageHeight,
      style: {
        width: imageWidth.toString(),
        height: imageHeight.toString(),
        transform: `translate(${viewport.x}px, ${viewport.y}px) scale(${viewport.zoom})`,
      },
    }).then(downloadImage)
  }, [nodes])

  const handleExportPdf = useCallback(
    async (options: PdfExportOptions) => {
      setIsExportingPdf(true)

      try {
        const nodesBounds = getNodesBounds(nodes)

        // Use dimensions optimized for A4 landscape (842 x 595 points)
        // Higher resolution for better quality: 3x scale
        const pdfImageWidth = 2526 // 842 * 3
        const pdfImageHeight = 1785 // 595 * 3

        // Calculate viewport with minimal padding and higher max zoom to fill the page
        const viewport = getViewportForBounds(
          nodesBounds,
          pdfImageWidth,
          pdfImageHeight,
          0.5, // minZoom
          4, // maxZoom - higher to allow more zoom on small diagrams
          0.1, // padding - minimal padding for tighter fit
        )

        const viewportElement = document.querySelector('.react-flow__viewport') as HTMLElement

        if (!viewportElement) {
          setIsExportingPdf(false)
          setExportPdfDialogOpen(false)
          return
        }

        // Capture diagram as PNG
        const dataUrl = await toPng(viewportElement, {
          backgroundColor: '#fff',
          width: pdfImageWidth,
          height: pdfImageHeight,
          style: {
            width: pdfImageWidth.toString(),
            height: pdfImageHeight.toString(),
            transform: `translate(${viewport.x}px, ${viewport.y}px) scale(${viewport.zoom})`,
          },
        })

        // Convert customer logo to base64 if it's a File object (only if branding is included)
        let logoDataUrl: string | null = null
        if (options.includeCustomerBranding) {
          logoDataUrl = customerLogoUrl
          if (customerLogoFile) {
            logoDataUrl = await new Promise<string>((resolve) => {
              const reader = new FileReader()
              reader.onloadend = () => resolve(reader.result as string)
              reader.readAsDataURL(customerLogoFile)
            })
          }
        }

        // Build contact info objects
        const seContact =
          options.seName || options.seEmail
            ? { name: options.seName, email: options.seEmail }
            : undefined
        const aeContact =
          options.aeName || options.aeEmail
            ? { name: options.aeName, email: options.aeEmail }
            : undefined

        // Generate PDF
        const pdfDoc = (
          <PlaygroundPdfDocument
            diagramImage={dataUrl}
            title={options.title}
            customerName={options.includeCustomerBranding ? customerName : undefined}
            customerLogoUrl={logoDataUrl}
            generatedAt={new Date().toISOString()}
            seContact={seContact}
            aeContact={aeContact}
          />
        )

        const blob = await pdf(pdfDoc).toBlob()

        // Download PDF
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `playground-${new Date().toISOString()}.pdf`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)

        // Close dialog on success
        setExportPdfDialogOpen(false)
      } catch (error) {
        console.error('Error generating PDF:', error)
        toaster.create({
          title: 'PDF export failed',
          description: error instanceof Error ? error.message : 'Failed to generate PDF',
          type: 'error',
        })
      } finally {
        setIsExportingPdf(false)
      }
    },
    [nodes, customerName, customerLogoUrl, customerLogoFile],
  )

  const handleExportImage = useCallback(
    async (options: ExportOptions) => {
      setIsExportingImage(true)

      try {
        const nodesBounds = getNodesBounds(nodes)

        // Use Full HD dimensions for the final image (1920x1080)
        // Diagram area will be captured at 2x scale for high quality
        const diagramImageWidth = 1920 * 2
        const diagramImageHeight = 960 * 2 // Leave room for header/footer

        // Calculate viewport with good coverage
        const viewport = getViewportForBounds(
          nodesBounds,
          diagramImageWidth,
          diagramImageHeight,
          0.5, // minZoom
          4, // maxZoom
          0.1, // padding
        )

        const viewportElement = document.querySelector('.react-flow__viewport') as HTMLElement

        if (!viewportElement) {
          setIsExportingImage(false)
          setExportImageDialogOpen(false)
          return
        }

        // Capture diagram as PNG
        const diagramDataUrl = await toPng(viewportElement, {
          backgroundColor: '#fff',
          width: diagramImageWidth,
          height: diagramImageHeight,
          style: {
            width: diagramImageWidth.toString(),
            height: diagramImageHeight.toString(),
            transform: `translate(${viewport.x}px, ${viewport.y}px) scale(${viewport.zoom})`,
          },
        })

        // Convert customer logo to base64 if it's a File object (only if branding is included)
        let logoDataUrl: string | null = null
        if (options.includeCustomerBranding) {
          logoDataUrl = customerLogoUrl
          if (customerLogoFile) {
            logoDataUrl = await new Promise<string>((resolve) => {
              const reader = new FileReader()
              reader.onloadend = () => resolve(reader.result as string)
              reader.readAsDataURL(customerLogoFile)
            })
          }
        }

        // Build contact info objects
        const seContact =
          options.seName || options.seEmail
            ? { name: options.seName, email: options.seEmail }
            : undefined
        const aeContact =
          options.aeName || options.aeEmail
            ? { name: options.aeName, email: options.aeEmail }
            : undefined

        // Create an offscreen div for rendering the layout
        const offscreenDiv = document.createElement('div')
        offscreenDiv.style.position = 'absolute'
        offscreenDiv.style.left = '-9999px'
        offscreenDiv.style.top = '-9999px'
        document.body.appendChild(offscreenDiv)

        // Render the ImageExportLayout component
        const root = createRoot(offscreenDiv)
        root.render(
          <ImageExportLayout
            diagramDataUrl={diagramDataUrl}
            title={options.title}
            customerName={options.includeCustomerBranding ? customerName : undefined}
            customerLogoUrl={logoDataUrl}
            generatedAt={new Date().toISOString()}
            seContact={seContact}
            aeContact={aeContact}
          />,
        )

        // Wait for rendering to complete
        await new Promise((resolve) => setTimeout(resolve, 100))

        // Capture the entire layout as PNG
        const layoutElement = offscreenDiv.firstElementChild as HTMLElement
        const finalImageDataUrl = await toPng(layoutElement, {
          width: 1920,
          height: 1080,
          backgroundColor: '#ffffff',
        })

        // Cleanup
        root.unmount()
        document.body.removeChild(offscreenDiv)

        // Download the image
        const link = document.createElement('a')
        link.href = finalImageDataUrl
        link.download = `playground-${new Date().toISOString()}.png`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        // Close dialog on success
        setExportImageDialogOpen(false)
      } catch (error) {
        console.error('Error generating image:', error)
        toaster.create({
          title: 'Image export failed',
          description: error instanceof Error ? error.message : 'Failed to generate image',
          type: 'error',
        })
      } finally {
        setIsExportingImage(false)
      }
    },
    [nodes, customerName, customerLogoUrl, customerLogoFile],
  )

  const _savePlaygroundToFile = () => {
    const content = {
      nodes,
      edges,
    }
    DownloadPlayground(content)
  }

  // Handler for customer logo changes
  const handleCustomerLogoChange = (file: File | null, url: string | null) => {
    setCustomerLogoFile(file)
    setCustomerLogoUrl(url)
  }

  // Handler for loading a saved playground
  const handleLoadPlayground = (playground: SavedPlaygroundDetail) => {
    // Reset the ID counter to avoid conflicts
    const maxId = Math.max(0, ...playground.nodes.map((n: any) => parseInt(n.id) || 0))
    id = maxId + 1

    // Load nodes and edges (normalize to ensure group zIndex)
    setNodes(normalizeNodes(playground.nodes as any))
    setEdges(playground.edges as any)

    // Load customer branding
    setCustomerName(playground.customerName || '')
    setCustomerLogoUrl(playground.customerLogoUrl || null)
    setCustomerLogoFile(null) // Clear any local file since we're loading from URL

    // Store current playground info for editing
    setCurrentPlaygroundId(playground.id)
    setCurrentPlaygroundName(playground.name)
    setCurrentPlaygroundIsPublic(playground.isPublic)

    // Fit view after nodes are rendered
    setTimeout(() => {
      fitView({ padding: 0.1, duration: 200 })
    }, 100)
  }

  // Handler for successful save
  const handleSaveSuccess = (playgroundId: string) => {
    setCurrentPlaygroundId(playgroundId)
  }

  // Helper to convert file to base64
  const fileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => {
        const result = reader.result as string
        // Remove the data URL prefix (e.g., "data:image/png;base64,")
        const base64 = result.split(',')[1]
        resolve(base64)
      }
      reader.onerror = reject
      reader.readAsDataURL(file)
    })
  }

  // Handler for image import
  const _handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) {
      return
    }

    // Validate file type
    if (!['image/png', 'image/jpeg', 'image/webp'].includes(file.type)) {
      toaster.create({
        title: 'Invalid file type',
        description: 'Please upload PNG, JPEG, or WebP images.',
        type: 'error',
      })
      return
    }

    setIsAnalyzingImage(true)
    try {
      // Convert file to base64
      const base64 = await fileToBase64(file)

      // Call AI API to analyze image (node types are fetched from database by backend)
      const result = await aiApi.analyzeImage({
        imageBase64: base64,
        mimeType: file.type,
      })

      // Reset the ID counter based on extracted nodes
      const maxId = Math.max(0, ...result.nodes.map((n) => parseInt(n.id) || 0))
      id = maxId + 1

      // Enrich nodes with data from our node database
      const enrichedNodes = result.nodes.map((node) => {
        const nodeInfo = nodeDataBySlug.get(node.data.label)
        return {
          ...node,
          data: {
            ...node.data,
            logoUrl: nodeInfo?.logoUrl || node.data.logoUrl,
            backgroundColor: nodeInfo?.backgroundColor || node.data.backgroundColor || '#E5E7EB',
            externalLink: nodeInfo?.externalLink || node.data.externalLink,
          },
          origin: [0.5, 0.0] as [number, number],
        }
      })

      // Replace playground content with extracted nodes and edges
      setNodes(enrichedNodes)
      setEdges(result.edges)

      // Reset customer branding
      setCustomerName('')
      setCustomerLogoUrl(null)
      setCustomerLogoFile(null)
      setCurrentPlaygroundId(null)
      setCurrentPlaygroundName('')
      setCurrentPlaygroundIsPublic(false)

      // Fit view after nodes are rendered
      setTimeout(() => {
        fitView({ padding: 0.1, duration: 200 })
      }, 100)

      // Show success toast
      toaster.create({
        title: 'Architecture imported',
        description: `Extracted ${result.nodes.length} nodes and ${result.edges.length} connections`,
        type: 'success',
      })
    } catch (error) {
      console.error('Image analysis failed:', error)
      toaster.create({
        title: 'Image analysis failed',
        description:
          error instanceof Error ? error.message : 'Failed to analyze the architecture image',
        type: 'error',
      })
    } finally {
      setIsAnalyzingImage(false)
      e.target.value = '' // Reset input so same file can be re-selected
    }
  }

  // Handler for applying AI actions to the playground
  const handleApplyAiActions = useCallback(
    (actions: PlaygroundAction[]) => {
      let maxId = Math.max(0, ...nodes.map((n) => parseInt(n.id) || 0))
      const idMap = new Map<string, string>() // Maps temporary IDs (new_1) to real IDs

      actions.forEach((action) => {
        if (action.type === 'add_node') {
          const newId = String(++maxId)
          // Map temporary ID to real ID for edge connections
          const tempIdMatch = action.name?.match(/new_(\d+)/)
          if (tempIdMatch) {
            idMap.set(`new_${tempIdMatch[1]}`, newId)
          }
          // Always map by index for predictability
          idMap.set(`new_${idMap.size + 1}`, newId)

          // Look up node data from the API
          const nodeInfo = nodeDataBySlug.get(action.slug)

          const newNode = {
            id: newId,
            position: action.position,
            type: 'dynamicNode',
            data: {
              label: action.slug,
              name: nodeInfo?.name || action.name,
              logoUrl: nodeInfo?.logoUrl,
              backgroundColor: nodeInfo?.backgroundColor || '#E5E7EB',
              externalLink: nodeInfo?.externalLink,
            },
            origin: [0.5, 0.0] as [number, number],
          }

          setNodes((nds) => nds.concat(newNode))
        } else if (action.type === 'remove_node') {
          // Remove node and connected edges
          setNodes((nds) => nds.filter((n) => n.id !== action.nodeId))
          setEdges((eds) =>
            eds.filter((e) => e.source !== action.nodeId && e.target !== action.nodeId),
          )
        } else if (action.type === 'add_edge') {
          // Resolve temporary IDs to real IDs
          const sourceId = idMap.get(action.sourceId) || action.sourceId
          const targetId = idMap.get(action.targetId) || action.targetId

          const newEdge = {
            id: `e${sourceId}-${targetId}`,
            source: sourceId,
            target: targetId,
            type: 'button',
            animated: true,
            style: { stroke: '#383838' },
            markerEnd: {
              type: MarkerType.ArrowClosed,
              color: '#383838',
            },
            data: action.label ? { label: action.label } : undefined,
          }

          setEdges((eds) => eds.concat(newEdge))
        } else if (action.type === 'remove_edge') {
          setEdges((eds) => eds.filter((e) => e.id !== action.edgeId))
        } else if (action.type === 'update_node') {
          setNodes((nds) =>
            nds.map((n) => {
              if (n.id === action.nodeId) {
                return {
                  ...n,
                  position: action.position || n.position,
                  data: {
                    ...n.data,
                    name: action.name || n.data.name,
                  },
                }
              }
              return n
            }),
          )
        }
      })
    },
    [nodes, nodeDataBySlug, setNodes, setEdges],
  )

  // Handler for AI chat messages
  const handleAiChat = useCallback(
    async (message: string, imageBase64?: string, imageMimeType?: string) => {
      // Add user message to chat
      const userMessage: ChatMessage = {
        role: 'user',
        content: message,
        timestamp: Date.now(),
      }
      setChatMessages((prev) => [...prev, userMessage])
      setIsChatLoading(true)
      setLastActionSummary(null)

      try {
        const response = await aiApi.playgroundChat({
          message,
          playgroundState: { nodes, edges },
          conversationHistory: chatMessages,
          imageBase64,
          imageMimeType,
        })

        // Add assistant message to chat
        const assistantMessage: ChatMessage = {
          role: 'assistant',
          content: response.message,
          timestamp: Date.now(),
        }
        setChatMessages((prev) => [...prev, assistantMessage])

        // Apply actions if any
        if (response.actions && response.actions.length > 0) {
          handleApplyAiActions(response.actions as PlaygroundAction[])
          setLastActionSummary(
            response.actionSummary || `Applied ${response.actions.length} action(s)`,
          )
        }
      } catch (error) {
        console.error('AI chat error:', error)
        const errorMessage: ChatMessage = {
          role: 'assistant',
          content: 'Sorry, I encountered an error. Please try again.',
          timestamp: Date.now(),
        }
        setChatMessages((prev) => [...prev, errorMessage])
        toaster.create({
          title: 'AI Chat Error',
          description: error instanceof Error ? error.message : 'Failed to get AI response',
          type: 'error',
        })
      } finally {
        setIsChatLoading(false)
      }
    },
    [nodes, edges, chatMessages, handleApplyAiActions],
  )

  // Handler to clear chat history
  const handleClearChatHistory = useCallback(() => {
    setChatMessages([])
    setLastActionSummary(null)
  }, [])

  // Handler for background image upload
  const handleBackgroundUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) {
      return
    }

    // Validate file type
    if (!['image/png', 'image/jpeg', 'image/webp', 'image/gif'].includes(file.type)) {
      toaster.create({
        title: 'Invalid file type',
        description: 'Please upload PNG, JPEG, WebP, or GIF images.',
        type: 'error',
      })
      return
    }

    // Create object URL for the image
    const url = URL.createObjectURL(file)
    setBackgroundImageUrl(url)
    e.target.value = '' // Reset input so same file can be re-selected
  }

  // Handler to clear background image
  const clearBackgroundImage = () => {
    if (backgroundImageUrl) {
      URL.revokeObjectURL(backgroundImageUrl)
    }
    setBackgroundImageUrl(null)
  }

  // Handler for changing node type
  const handleChangeNodeType = useCallback(
    (nodeId: string, newNodeData: PlaygroundNodeMenuItem) => {
      setNodes((nodes) =>
        nodes.map((node) => {
          if (node.id === nodeId) {
            return {
              ...node,
              type: 'dynamicNode',
              data: {
                ...node.data,
                label: newNodeData.slug,
                name: newNodeData.name,
                logoUrl: newNodeData.logoUrl,
                backgroundColor: newNodeData.backgroundColor || '#E5E7EB',
                externalLink: newNodeData.externalLink,
              },
            }
          }
          return node
        }),
      )
    },
    [setNodes],
  )

  // Handler for loading a template
  const handleLoadTemplate = (template: FlowTemplate) => {
    // Reset the ID counter based on template nodes
    const maxId = Math.max(0, ...template.nodes.map((n: any) => parseInt(n.id) || 0))
    id = maxId + 1

    // Load nodes and edges from template (normalize to ensure group zIndex)
    setNodes(normalizeNodes(template.nodes as any))
    setEdges(template.edges as any)

    // Reset customer branding for fresh template
    setCustomerName('')
    setCustomerLogoUrl(null)
    setCustomerLogoFile(null)

    // Clear current playground info since this is a new template
    setCurrentPlaygroundId(null)
    setCurrentPlaygroundName('')
    setCurrentPlaygroundIsPublic(false)

    // Fit view after nodes are rendered
    setTimeout(() => {
      fitView({ padding: 0.1, duration: 200 })
    }, 100)
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  const onConnect = useCallback(
    (params) => {
      params.type = 'button'
      params.animated = true
      params.style = { stroke: '#383838' }
      params.markerEnd = {
        type: MarkerType.ArrowClosed,
        color: '#383838',
      }
      params.data = { label: '', color: '#383838', bold: false }
      setEdges((els) => addEdge(params, els))
    },
    [setEdges],
  )

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  const onNodeContextMenu = useCallback(
    (event, node) => {
      event.preventDefault()

      // Find the node element in the DOM to get its screen position
      const nodeElement = document.querySelector(`[data-id="${node.id}"]`)
      if (!nodeElement) {
        // Fallback to mouse position if node element not found
        setMenu({
          id: node.id,
          top: event.clientY,
          left: event.clientX,
        })
        return
      }

      const nodeRect = nodeElement.getBoundingClientRect()

      // Position menu at the center of the node
      const menuWidth = 150
      const menuHeight = 120
      const menuTop = nodeRect.top + nodeRect.height / 2 - menuHeight / 2
      const menuLeft = nodeRect.left + nodeRect.width / 2 - menuWidth / 2

      setMenu({
        id: node.id,
        top: menuTop,
        left: menuLeft,
      })
    },
    [setMenu],
  )

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  const onNodesDelete = useCallback(
    (deleted) => {
      setEdges(
        deleted.reduce((acc, node) => {
          const incomers = getIncomers(node, nodes, edges)
          const outgoers = getOutgoers(node, nodes, edges)
          const connectedEdges = getConnectedEdges([node], edges)

          const remainingEdges = acc.filter((edge) => !connectedEdges.includes(edge))

          const createdEdges = incomers.flatMap(({ id: source }) =>
            outgoers.map(({ id: target }) => ({
              id: `${source}->${target}`,
              source,
              target,
              type: 'button',
              animated: true,
              style: { stroke: '#383838' },
              markerEnd: {
                type: MarkerType.ArrowClosed,
                color: '#383838',
              },
              data: { label: '', color: '#383838', bold: false },
            })),
          )

          return [...remainingEdges, ...createdEdges]
        }, edges),
      )
    },
    [setEdges, edges, nodes],
  )

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  const onPaneClick = useCallback(() => setMenu(null), [setMenu])

  // Handler for node drag stop - manages group parenting
  const onNodeDragStop = useCallback(
    (_event: React.MouseEvent, node: any) => {
      // Skip if the dragged node is a group itself
      if (node.type === 'groupNode') {
        return
      }

      // Find all group nodes
      const groupNodes = nodes.filter((n) => n.type === 'groupNode')

      // Check if node is inside any group
      let newParentId: string | undefined

      for (const group of groupNodes) {
        // Skip if this group is the current parent
        if (node.parentId === group.id) {
          continue
        }

        const groupWidth = group.style?.width || group.width || 300
        const groupHeight = group.style?.height || group.height || 200

        // Check if node center is within group bounds
        const nodeCenter = {
          x: node.position.x + 40, // Assuming node width ~80
          y: node.position.y + 40, // Assuming node height ~80
        }

        // For nodes with a parent, position is relative to parent
        // For top-level nodes, position is absolute
        const groupBounds = {
          left: group.position.x,
          right: group.position.x + groupWidth,
          top: group.position.y,
          bottom: group.position.y + groupHeight,
        }

        // Adjust node position if it has a different parent
        let absoluteNodeCenter = nodeCenter
        if (node.parentId && node.parentId !== group.id) {
          const currentParent = nodes.find((n) => n.id === node.parentId)
          if (currentParent) {
            absoluteNodeCenter = {
              x: currentParent.position.x + nodeCenter.x,
              y: currentParent.position.y + nodeCenter.y,
            }
          }
        }

        if (
          absoluteNodeCenter.x >= groupBounds.left &&
          absoluteNodeCenter.x <= groupBounds.right &&
          absoluteNodeCenter.y >= groupBounds.top &&
          absoluteNodeCenter.y <= groupBounds.bottom
        ) {
          newParentId = group.id
          break
        }
      }

      // Update node's parent if it changed
      if (newParentId !== node.parentId) {
        setNodes((nds) =>
          nds.map((n) => {
            if (n.id === node.id) {
              if (newParentId) {
                // Moving into a group - convert to relative position
                const newParent = nds.find((p) => p.id === newParentId)
                if (newParent) {
                  return {
                    ...n,
                    parentId: newParentId,
                    position: {
                      x: node.position.x - newParent.position.x,
                      y: node.position.y - newParent.position.y,
                    },
                    extent: 'parent' as const,
                  }
                }
              } else {
                // Moving out of a group - convert to absolute position
                const oldParent = nds.find((p) => p.id === node.parentId)
                if (oldParent) {
                  return {
                    ...n,
                    parentId: undefined,
                    position: {
                      x: oldParent.position.x + node.position.x,
                      y: oldParent.position.y + node.position.y,
                    },
                    extent: undefined,
                  }
                }
              }
            }
            return n
          }),
        )
      }
    },
    [nodes, setNodes],
  )

  // Handler for connection end - creates node on edge drop
  const onConnectEnd = useCallback(
    (event: MouseEvent | TouchEvent, connectionState: any) => {
      // Only handle if dropped on empty canvas (not on a valid target)
      if (connectionState.isValid) {
        return
      }
      if (!connectionState.fromNode) {
        return
      }

      // Get the drop position
      const clientX = 'clientX' in event ? event.clientX : event.touches?.[0]?.clientX
      const clientY = 'clientY' in event ? event.clientY : event.touches?.[0]?.clientY

      if (clientX === undefined || clientY === undefined) {
        return
      }

      const position = screenToFlowPosition({
        x: clientX,
        y: clientY,
      })

      // Find the generic node from our database
      const genericNodeData = nodeDataBySlug.get('generic')

      const newNodeId = getId()
      const newNode = {
        id: newNodeId,
        position,
        type: genericNodeData ? 'dynamicNode' : 'genericNode',
        data: genericNodeData
          ? {
              label: genericNodeData.slug,
              name: genericNodeData.name,
              logoUrl: genericNodeData.logoUrl,
              backgroundColor: genericNodeData.backgroundColor || '#E5E7EB',
            }
          : { label: 'generic' },
        origin: [0.5, 0.0] as [number, number],
      }

      // Determine edge direction based on which handle was dragged
      const isSourceHandle = connectionState.fromHandle?.type === 'source'
      const newEdge = {
        id: `e${connectionState.fromNode.id}-${newNodeId}`,
        source: isSourceHandle ? connectionState.fromNode.id : newNodeId,
        target: isSourceHandle ? newNodeId : connectionState.fromNode.id,
        sourceHandle: isSourceHandle ? connectionState.fromHandle?.id : null,
        targetHandle: isSourceHandle ? null : connectionState.fromHandle?.id,
        type: 'button',
        animated: true,
        style: { stroke: '#383838' },
        markerEnd: {
          type: MarkerType.ArrowClosed,
          color: '#383838',
        },
        data: { label: '', color: '#383838', bold: false },
      }

      setNodes((nds) => nds.concat(newNode))
      setEdges((eds) => eds.concat(newEdge))
    },
    [screenToFlowPosition, nodeDataBySlug, setNodes, setEdges],
  )

  return (
    <Box position="relative" w="100%" flex="1" minH="0" overflow="hidden">
      {/* Toolbar */}
      <Box
        position="absolute"
        top={3}
        left={3}
        zIndex={1000}
        className="faddbutton-bringToFront"
        bg="bg.panel"
        borderWidth="1px"
        borderColor="border"
        borderRadius="lg"
        shadow="md"
        p={2}
        // Override the `.faddbutton-bringToFront { width: 0 }` rule (unlayered CSS)
        // so the panel background wraps the toolbar buttons.
        style={{ width: 'fit-content' }}
      >
        <HStack gap={2}>
          {/* Add Items Menu */}
          <Menu.Root>
            <Menu.Trigger asChild>
              <IconButton
                aria-label="Add item"
                bg="brand.solid"
                _hover={{ bg: 'brand.fg' }}
                size="md"
              >
                <Add size={20} />
              </IconButton>
            </Menu.Trigger>
            <Portal>
              <Menu.Positioner>
                <Menu.Content minW="200px" zIndex={1000}>
                  {/* HiveMQ category first (from API) */}
                  {menuData?.categories
                    .filter((cat) => cat.name === 'HiveMQ')
                    .map((category) => (
                      <Menu.ItemGroup key={category.name}>
                        <Menu.ItemGroupLabel>{category.name}</Menu.ItemGroupLabel>
                        {category.nodes.map((node) => (
                          <Menu.Item
                            key={node.slug}
                            value={node.slug}
                            onClick={() => onAddItem(node.slug)}
                          >
                            <HStack gap={2}>
                              {node.logoUrl ? (
                                <img
                                  src={node.logoUrl}
                                  alt={node.name}
                                  style={{ width: 16, height: 16, objectFit: 'contain' }}
                                />
                              ) : (
                                <BoxIcon size={16} />
                              )}
                              <Text>{node.name}</Text>
                            </HStack>
                          </Menu.Item>
                        ))}
                      </Menu.ItemGroup>
                    ))}

                  <Menu.Separator />

                  {/* Other dynamic categories from API */}
                  {menuData?.categories
                    .filter((cat) => cat.name !== 'HiveMQ')
                    .map((category) => (
                      <DynamicSubMenu
                        key={category.name}
                        category={category}
                        onAddItem={onAddItem}
                      />
                    ))}

                  {/* Uncategorized nodes at root level */}
                  {menuData?.uncategorized && menuData.uncategorized.length > 0 && (
                    <>
                      <Menu.Separator />
                      {menuData.uncategorized.map((node) => (
                        <Menu.Item
                          key={node.slug}
                          value={node.slug}
                          onClick={() => onAddItem(node.slug)}
                        >
                          <HStack gap={2}>
                            {node.logoUrl ? (
                              <img
                                src={node.logoUrl}
                                alt={node.name}
                                style={{ width: 16, height: 16, objectFit: 'contain' }}
                              />
                            ) : (
                              <BoxIcon size={16} />
                            )}
                            <Text>{node.name}</Text>
                          </HStack>
                        </Menu.Item>
                      ))}
                    </>
                  )}
                </Menu.Content>
              </Menu.Positioner>
            </Portal>
          </Menu.Root>

          {/* Add Group Button */}
          <IconButton
            aria-label="Add group"
            variant="outline"
            size="md"
            onClick={onAddGroup}
            w={24}
          >
            <GroupObjects size={20} /> Group
          </IconButton>

          {/* Save Button */}
          <IconButton
            aria-label="Save to database"
            variant="outline"
            size="md"
            onClick={() => setSaveDialogOpen(true)}
            w={20}
          >
            <Save size={20} /> Save
          </IconButton>

          {/* Share Button (only visible when playground is saved) */}
          {currentPlaygroundId && (
            <IconButton
              aria-label="Share playground"
              variant="outline"
              size="md"
              onClick={() => setShareDialogOpen(true)}
              w={20}
            >
              <Share2 size={20} /> Share
            </IconButton>
          )}

          {/* Load Button */}
          <IconButton
            aria-label="Load from database"
            variant="outline"
            size="md"
            onClick={() => setLoadDialogOpen(true)}
            w={20}
          >
            <FolderOpen size={20} /> Load
          </IconButton>

          {/* Clean Button */}
          <IconButton
            aria-label="Clean"
            variant="outline"
            size="md"
            onClick={() => {
              setNodes([])
              setEdges([])
              setCustomerName('')
              setCustomerLogoUrl(null)
              setCustomerLogoFile(null)
              setCurrentPlaygroundId(null)
              setCurrentPlaygroundName('')
              setCurrentPlaygroundIsPublic(false)
              clearBackgroundImage()
              setCanvasColor(DEFAULT_CANVAS_COLOR)
              setHexInput(DEFAULT_CANVAS_COLOR)
              handleClearChatHistory()
            }}
            w={'20'}
          >
            <Clean size={20} /> Clean
          </IconButton>

          {/* Templates Button */}
          <IconButton
            aria-label="Load from templates"
            variant="outline"
            size="md"
            onClick={() => setTemplateGalleryOpen(true)}
            w={'34'}
            p={'2'}
          >
            <Template size={20} /> Templates
          </IconButton>

          {/* Background Settings Popover */}
          <Popover.Root>
            <Popover.Trigger asChild>
              <IconButton
                aria-label="Background settings"
                variant="outline"
                size="md"
                w={'38'}
                p={'2'}
              >
                <Palette size={20} /> Background
              </IconButton>
            </Popover.Trigger>
            <Portal>
              <Popover.Positioner>
                <Popover.Content w="260px">
                  <Popover.Body>
                    {/* Section 1: Canvas Color */}
                    <Text fontWeight="medium" fontSize="sm" mb="2">
                      Canvas Color
                    </Text>
                    <SimpleGrid columns={5} gap="2" mb="2">
                      {CANVAS_COLORS.map((c) => (
                        <Box
                          key={c.value}
                          as="button"
                          w="28px"
                          h="28px"
                          borderRadius="full"
                          bg={c.value}
                          border="1px solid"
                          borderColor="gray.300"
                          outline={
                            canvasColor.toUpperCase() === c.value.toUpperCase()
                              ? '2px solid'
                              : 'none'
                          }
                          outlineColor="blue.500"
                          outlineOffset="2px"
                          cursor="pointer"
                          title={c.name}
                          aria-label={`Set canvas color to ${c.name}`}
                          onClick={() => {
                            setCanvasColor(c.value)
                            setHexInput(c.value)
                          }}
                        />
                      ))}
                    </SimpleGrid>
                    <HStack gap="2" mb="1">
                      <Input
                        size="sm"
                        placeholder="#F7F9FB"
                        value={hexInput}
                        flex="1"
                        onChange={(e) => setHexInput(e.target.value)}
                        onBlur={() => {
                          if (/^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(hexInput)) {
                            setCanvasColor(hexInput)
                          } else {
                            setHexInput(canvasColor)
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            if (/^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(hexInput)) {
                              setCanvasColor(hexInput)
                            } else {
                              setHexInput(canvasColor)
                            }
                          }
                        }}
                      />
                      <Box position="relative" w="32px" h="32px" flexShrink={0}>
                        <input
                          type="color"
                          value={canvasColor}
                          onChange={(e) => {
                            setCanvasColor(e.target.value)
                            setHexInput(e.target.value)
                          }}
                          style={{
                            position: 'absolute',
                            inset: 0,
                            width: '100%',
                            height: '100%',
                            padding: 0,
                            border: 'none',
                            borderRadius: '50%',
                            cursor: 'pointer',
                            background: 'none',
                          }}
                          title="Pick a color"
                          aria-label="Pick a custom canvas color"
                        />
                      </Box>
                    </HStack>
                    <Button
                      variant="outline"
                      size="2xs"
                      fontSize="xs"
                      fontWeight="medium"
                      borderRadius="full"
                      px="3"
                      onClick={() => {
                        setCanvasColor(DEFAULT_CANVAS_COLOR)
                        setHexInput(DEFAULT_CANVAS_COLOR)
                      }}
                    >
                      Reset to default
                    </Button>

                    <Separator my="3" />

                    {/* Section 2: Background Image */}
                    <Text fontWeight="medium" fontSize="sm" mb="2">
                      Background Image
                    </Text>
                    {backgroundImageUrl ? (
                      <HStack>
                        <Text fontSize="sm" flex="1">
                          Image loaded
                        </Text>
                        <Button
                          size="xs"
                          variant="outline"
                          colorPalette="red"
                          onClick={clearBackgroundImage}
                        >
                          Clear
                        </Button>
                      </HStack>
                    ) : (
                      <Button
                        size="sm"
                        variant="outline"
                        w="full"
                        onClick={() => backgroundInputRef.current?.click()}
                      >
                        <Image size={16} /> Upload Image
                      </Button>
                    )}
                  </Popover.Body>
                </Popover.Content>
              </Popover.Positioner>
            </Portal>
          </Popover.Root>
          <input
            type="file"
            ref={backgroundInputRef}
            accept="image/png,image/jpeg,image/webp,image/gif"
            style={{ display: 'none' }}
            onChange={handleBackgroundUpload}
          />

          {/* Export PNG Button */}
          <IconButton
            aria-label="Export as PNG"
            variant="outline"
            size="md"
            onClick={() => setExportImageDialogOpen(true)}
            disabled={nodes.length === 0}
            w={'34'}
            p={'2'}
          >
            <DropPhotoFilled size={20} /> PNG Export
          </IconButton>

          {/* PDF Export Button */}
          <IconButton
            aria-label="Export as PDF"
            variant="outline"
            size="md"
            onClick={() => setExportPdfDialogOpen(true)}
            disabled={nodes.length === 0}
            w={'38'}
            p={'2'}
          >
            <FileText size={20} /> PDF Export
          </IconButton>

          {/* Ask AI Button */}
          <IconButton
            aria-label="Ask AI"
            variant="solid"
            bg="brand.solid"
            _hover={{ bg: 'brand.fg' }}
            size="md"
            onClick={() => setAiDrawerOpen(true)}
            w={'30'}
            p={'2'}
          >
            <Sparkles size={20} /> Ask AI
          </IconButton>

          {/* Save as Template Button (Admin only) */}
          {isAdmin && (
            <IconButton
              aria-label="Save as template"
              variant="outline"
              size="md"
              colorPalette="brand"
              onClick={() => setSaveTemplateDialogOpen(true)}
              disabled={nodes.length === 0}
              w={'50'}
              p={'2'}
            >
              <Template size={20} /> To Template
            </IconButton>
          )}
        </HStack>
      </Box>

      {/* Customer Card */}
      <CustomerCard
        customerName={customerName}
        customerLogoUrl={customerLogoUrl}
        customerLogoFile={customerLogoFile}
        onCustomerNameChange={setCustomerName}
        onCustomerLogoChange={handleCustomerLogoChange}
      />

      {/* Background Image */}
      {backgroundImageUrl && (
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          zIndex={0}
          pointerEvents="none"
          opacity={0.3}
          style={{
            backgroundImage: `url(${backgroundImageUrl})`,
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        />
      )}

      {/* ReactFlow Canvas */}
      <ReactFlow
        ref={ref}
        nodes={nodes}
        nodeTypes={nodeTypes}
        edges={edges}
        edgeTypes={edgeTypes as EdgeTypes}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onNodesDelete={onNodesDelete}
        onConnect={onConnect}
        onConnectEnd={onConnectEnd}
        onNodeDragStop={onNodeDragStop}
        onPaneClick={onPaneClick}
        onNodeContextMenu={onNodeContextMenu}
        fitView
        style={{ backgroundColor: backgroundImageUrl ? 'transparent' : canvasColor }}
      >
        <Background />
        {menu && (
          <ContextMenu
            onClose={onPaneClick}
            menuData={menuData}
            onChangeNodeType={handleChangeNodeType}
            {...menu}
          />
        )}
        <Controls position="bottom-right" style={{ marginBottom: 40, marginRight: 15 }} />
        <MiniMap
          zoomable
          pannable
          position="bottom-left"
          style={{ marginBottom: 40, marginLeft: 15 }}
        />
      </ReactFlow>

      {/* Save Dialog */}
      {saveDialogOpen && (
        <SavePlaygroundDialog
          nodes={nodes}
          edges={getFlowEdges()}
          customerName={customerName}
          customerLogoFile={customerLogoFile}
          onClose={() => setSaveDialogOpen(false)}
          onSuccess={handleSaveSuccess}
          existingPlaygroundId={currentPlaygroundId}
          existingName={currentPlaygroundName}
          existingIsPublic={currentPlaygroundIsPublic}
        />
      )}

      {/* Load Dialog */}
      {loadDialogOpen && (
        <LoadPlaygroundDialog
          onClose={() => setLoadDialogOpen(false)}
          onLoad={handleLoadPlayground}
        />
      )}

      {/* Template Gallery */}
      {templateGalleryOpen && (
        <TemplateGallery
          onClose={() => setTemplateGalleryOpen(false)}
          onSelectTemplate={handleLoadTemplate}
        />
      )}

      {/* Save as Template Dialog (Admin only) */}
      {saveTemplateDialogOpen && (
        <SaveTemplateDialog
          nodes={nodes}
          edges={edges}
          onClose={() => setSaveTemplateDialogOpen(false)}
        />
      )}

      {/* Export PDF Dialog */}
      {exportPdfDialogOpen && (
        <ExportPdfDialog
          customerName={customerName}
          hasCustomerLogo={!!(customerLogoUrl || customerLogoFile)}
          onClose={() => setExportPdfDialogOpen(false)}
          onExport={handleExportPdf}
          isExporting={isExportingPdf}
        />
      )}

      {/* Export Image Dialog */}
      {exportImageDialogOpen && (
        <ExportImageDialog
          customerName={customerName}
          hasCustomerLogo={!!(customerLogoUrl || customerLogoFile)}
          onClose={() => setExportImageDialogOpen(false)}
          onExport={handleExportImage}
          isExporting={isExportingImage}
        />
      )}

      {/* Share Playground Dialog */}
      {shareDialogOpen && currentPlaygroundId && (
        <SharePlaygroundDialog
          playgroundId={currentPlaygroundId}
          playgroundName={currentPlaygroundName || 'Untitled Playground'}
          onClose={() => setShareDialogOpen(false)}
        />
      )}

      {/* AI Chat Drawer */}
      <AiChatDrawer
        isOpen={aiDrawerOpen}
        onClose={() => setAiDrawerOpen(false)}
        messages={chatMessages}
        isLoading={isChatLoading}
        onSendMessage={handleAiChat}
        onClearHistory={handleClearChatHistory}
        lastActionSummary={lastActionSummary}
      />
    </Box>
  )
}

function PlaygroundPage() {
  return (
    <ReactFlowProvider>
      <PlaygroundContent />
    </ReactFlowProvider>
  )
}
